import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import deliveryAPI from '../../api/delivery';
import { Types, Creators as DeliveryCreators } from '../../reducers/delivery';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';

function* thirdsRequest() {
  try {
    const { cart, customer, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const cartId = cart.id || customer.cartId || getCartId();

    const data = yield call(deliveryAPI.getThirdParty, cartId, siteId);

    yield put(DeliveryCreators.thirdsSuccess(data));
  } catch (error) {
    yield put(DeliveryCreators.thirdsFailed(null, formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.THIRDS_REQUEST, thirdsRequest);
}
